import { render, staticRenderFns } from "./RightImage.vue?vue&type=template&id=5146be40&scoped=true"
import script from "./RightImage.vue?vue&type=script&lang=js"
export * from "./RightImage.vue?vue&type=script&lang=js"
import style0 from "./RightImage.vue?vue&type=style&index=0&id=5146be40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5146be40",
  null
  
)

export default component.exports